/****************************************************************************
* Footer primary
****************************************************************************/

function fnFooterPrimary( i, oFooter ) {

	/**
	* Element
	*/
	var oFooter 					= $( oFooter ),
		oScrollUpButton				= $( 'i.arrow-up', oFooter );

	/***************
	* Scroll to top
	***************/
	oScrollUpButton.on( 'click', function() {

        $( 'body, html' ).animate({
	        scrollTop: 0,
	    }, 1000 );

    } );

}



// END OF DOCUMENT
